import React, { useEffect, useState, useContext, useRef } from "react";

import { Icon } from "@iconify/react";
import {
  AddCentre,
  getCentres,
  useGetCentres,
  useGetPeople,
  addMember,
  removeMember,
} from "../../api/settings";
import AddUpdateCentres from "../../components/AddUpdateCenters";
import Skeleton from "@mui/material/Skeleton";
import Avatar from "@mui/material/Avatar";
import Swal from "sweetalert2";
import { toast } from "sonner";
import AddMember from "../../components/AddMember";
import { AuthContext } from "../../context/AuthContextProvider";
import { BlankPreview } from "../../components/BlankPreview";
import nopreview from "../../assets/images/others/no-preview.png";
import { RequireAuth } from "../../RequireAuth.jsx";
import { set, sort } from "lodash";
import moment from "moment";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { id, is } from "date-fns/locale";
import SelectCenter from "../../components/SelectCenter.jsx";
import FilterSelect from "../../components/FilterSelect.jsx";
import { se } from "date-fns/locale";
import useCreditWallet from "../../hooks/useCreditWallet";
import {
  Autocomplete,
  TextField,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  ListItemText,
  OutlinedInput,
  Menu,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  CircularProgress,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  InputAdornment,
  Grid,
  Radio,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CustomFilters from "../../components/Filters/Filters.jsx";
import TypeIcon from "../../components/Reusables/HubSpokeIcon/TypeIcon.jsx";
import SearchIconSvg from "../../assets/icons/searchIcon.svg";
const data = [
  "Eugenia",
  "Bryan",
  "Linda",
  "Nancy",
  "Lloyd",
  "Alice",
  "Julia",
  "Albert",
].map((item) => ({ label: item, value: item }));

const Centres = ({ onTotalChange }) => {
  const navigate = useNavigate();
  // const [centres, setCentres] = useState([]);
  const { setFilter } = useContext(AuthContext);
  const [manageCenters, setManageCentres] = useState(true);

  const [addCenters, setAddCentres] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const { fetchMainCentres } = useContext(AuthContext);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);

  const [args, setArgs] = useState({ page, limit });
  const { centres, isLoading, pagination } = useGetCentres(args);
  const [specificCenter, setSpecificCenter] = useState(null);

  const [centersData, setCentersData] = useState(() =>
    Array.isArray(centres) ? centres : [],
  );
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const listRef = useRef(null);

  const handleManageCenters = (status) => {
    setManageCentres(status);
  };
  const toIndexedObject = (arr) => {
    if (!Array.isArray(arr)) return undefined;
    return arr.reduce((acc, val, i) => {
      acc[i] = val;
      return acc;
    }, {});
  };

  useEffect(() => {
    if (!centres) return;
    setCentersData((prev) => {
      if (page === 1) return centres; // reset
      const existingIds = new Set(prev.map((c) => c.id));
      const newItems = centres.filter((c) => !existingIds.has(c.id));
      return [...prev, ...newItems];
    });
    setIsLoadingMore(false);
  }, [centres, page]);

  useEffect(() => {
    if (typeof onTotalChange !== "function") return;

    // Prefer server-provided pagination.total if present and numeric
    if (pagination && typeof pagination.total === "number") {
      onTotalChange(pagination.total);
      return;
    }

    // Fallback to array length (current merged list)
    onTotalChange(Array.isArray(centersData) ? centersData.length : 0);
  }, [pagination, centersData, onTotalChange]);

  // check if more pages available
  const hasMore = (() => {
    if (pagination?.totalPages) {
      return page < pagination.totalPages;
    }
    return Array.isArray(centres) && centres.length === limit;
  })();

  // SCROLL HANDLER
  const handleScroll = (e) => {
    const target = e.currentTarget;
    const threshold = 120; // px from bottom
    const reachedBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - threshold;

    if (reachedBottom && !isLoadingMore && hasMore) {
      setIsLoadingMore(true);
      const nextPage = page + 1;
      setPage(nextPage);
      setArgs((prev) => ({ ...prev, page: nextPage, limit }));
    }
  };

  const handleAddCenters = (status) => {
    setAddCentres(false);
    setManageCentres(status);

    // Reset list + scroll
    setPage(1);
    setCentersData([]);
    setIsLoadingMore(false);

    setArgs((prev) => ({
      ...prev,
      page: 1,
      limit,
      reload: Math.floor(Math.random() * 100) + 1,
    }));

    setFilter((prev) => ({
      ...prev,
      page: 1,
      limit,
      reload: Math.floor(Math.random() * 100) + 1,
    }));
  };

  // const getCenterType = (center) => {
  //   if (Array.isArray(center.hierarchy) && center.hierarchy.length > 0) {
  //     return center.hierarchy[center.hierarchy.length - 1].type; // hub or spoke
  //   }
  //   return null;
  // };

  const handleFilter = (data) => {
    setPage(1);
    setCentersData([]);
    setIsLoadingMore(false);

    setArgs((prev) => ({
      ...prev,
      type: toIndexedObject(data.type),
      status: toIndexedObject(data.status),
      role: toIndexedObject(data.role),

      sort: data.sort || "desc",
      searchText: data.searchText || "",
      centerType: data.centerType,
      centerIds: data.centerIds,
      page: 1,
      limit,
    }));
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setArgs((prev) => ({ ...prev, page: newPage, limit }));
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
    setArgs((prev) => ({ ...prev, page: 1, limit: newLimit }));
  };

  // const data = [
  //   "Eugenia",
  //   "Bryan",
  //   "Linda",
  //   "Nancy",
  //   "Lloyd",
  //   "Alice",
  //   "Julia",
  //   "Albert",
  // ].map((item) => ({ label: item, value: item }));

  const handleCustomFilterApply = (cf) => {
    setPage(1);

    setArgs((prev) => ({
      ...prev,
      page: 1,
      limit: 50,

      // SORT
      sort: cf.sort || "desc",

      // SEARCH
      searchText: cf.searchText || "",

      // TYPE (ARRAY → BACKEND EXPECTS ARRAY)
      type: cf.type?.length ? cf.type : undefined,

      // CENTERS
      centerIds: cf.spokeIds.length
        ? JSON.stringify(cf.spokeIds)
        : cf.hubIds.length
          ? JSON.stringify(cf.hubIds)
          : undefined,

      // DATES
      dateFrom: cf.dateFrom || undefined,
      dateTo: cf.dateTo || undefined,
    }));
  };

  return (
    <>
      {addCenters ? (
        <>
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <h5
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setAddCentres(false);
                }}
              >
                <strong>
                  <i className="fa fa-angle-left"></i> Add Center
                </strong>
              </h5>
              <AddUpdateCentres
                type="add"
                handleManageCenters={handleAddCenters}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="row">
          <div className="col-md-12 ">
            <Filter
              handleFilter={handleFilter}
              setSelectedCenter={setSelectedCenter}
            />
            <CustomFilters
              component="centres"
              onApply={handleCustomFilterApply}
            />


            {isLoading && centersData.length === 0 ? (
              <div className="p-3">
                <div className="row">
                  {[1, 2, 3].map((_, idx) => (
                    <div key={idx} className="mb-4">
                      <Skeleton variant="rectangular" animation="wave" height={50} width="100%" style={{
                        borderRadius: "10px",
                        boxShadow: "var(--app-shadow)",
                      }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <Box sx={{ mt: 2 }}>
                {centersData.length > 0 ? (
                  <TableContainer className="app-table-card"
                    component={Paper}
                    sx={{
                      maxHeight: "70vh",
                      overflowY: "auto",
                    }}
                    onScroll={handleScroll}
                    ref={listRef}
                  >
                    <Table
                      stickyHeader
                      sx={{
                        backgroundColor: "var(--app-surface-2)",
                        borderCollapse: "separate",
                        borderSpacing: "0 10px",
                        "& th": {
                          borderBottom: "none",
                          fontWeight: 800,
                          fontSize: "13px",
                          color: "#A3A3A3",
                          py: 1.5,
                        },
                        "& td": {
                          borderBottom: "none",
                          fontSize: "15px",
                          py: 1.5,
                          px: 2,
                          color: "var(--app-text)",
                        },
                      }}
                    >
                      <TableHead>
                        <TableRow sx={{ fontFamily: "Figtree" }}>
                          {[
                            "CENTRE NAME",
                            "CONTACT NUMBER",
                            "TYPE",
                            "FACILITY TYPE",
                            "ADDRESS",
                          ].map((heading, idx) => (
                            <TableCell
                              key={idx}
                              align="left"
                              sx={{
                                backgroundColor: "var(--app-surface-2)",

                                ...(heading === "CONTACT NUMBER" && {
                                  minWidth: "180px",
                                  whiteSpace: "nowrap",
                                }),
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "15px",
                                  fontWeight: 800,
                                  fontFamily: "Figtree",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {heading}
                              </Typography>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {centersData.map((center, index) => (
                          <React.Fragment key={index}>
                            {/* Hub Row */}
                            <TableRow
                              sx={{
                                backgroundColor: "var(--app-surface)",
                                borderRadius: "8px",

                                "& td, & td *": {
                                  fontWeight: 600,
                                },

                                "& > *:first-of-type": {
                                  borderTopLeftRadius: "8px",
                                  borderBottomLeftRadius: "8px",
                                },
                                "& > *:last-of-type": {
                                  borderTopRightRadius: "8px",
                                  borderBottomRightRadius: "8px",
                                },
                                fontFamily: "Figtree",
                              }}
                            >
                              <TableCell>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={1.5}
                                >
                                  <Avatar
                                    src={center.logo || undefined}
                                    variant="square"
                                    sx={{
                                      width: 32,
                                      height: 32,
                                      backgroundColor: "#f0f0f0",
                                      mr: 1,
                                    }}
                                  >
                                    {!center.logo && (
                                      <Icon
                                        icon="icon-park-solid:hospital-three"
                                        width="25"
                                        height="25"
                                        style={{ color: "var(--app-text)" }}
                                      />
                                    )}
                                  </Avatar>
                                  <Box>
                                    <Typography
                                      sx={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        fontWeight: 600,
                                      }}
                                      onClick={() =>
                                        navigate(
                                          `/settings/centres/${center.id}`,
                                        )
                                      }
                                    >
                                      {center.name}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>

                              <TableCell>
                                {center.phone
                                  ? `${center.countryCode ?? ""} ${center.phone
                                  }`
                                  : "-"}
                              </TableCell>

                              <TableCell>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={0.5}
                                >
                                  <TypeIcon type={center.centerType} size={15} />
                                  {`${center.centerType
                                    .charAt(0)
                                    .toUpperCase()}${center.centerType
                                      .slice(1)
                                      .toLowerCase()} Centre`}
                                </Box>
                              </TableCell>

                              <TableCell>
                                <i className="bi bi-hospital me-2" />
                                {center.type || "--"}
                              </TableCell>

                              <TableCell>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  justifyContent="space-between"
                                  sx={{ width: "80%" }}
                                >
                                  <Typography sx={{ fontSize: "15px" }}>
                                    {center.address?.area || "--"},{" "}
                                    {center.address?.city || "--"}
                                  </Typography>
                                  {center.isAbhaVerified && (
                                    <Box
                                      sx={{
                                        display: "inline-block",
                                        backgroundColor: "#E7F7E7",
                                        color: "#2C7A2C",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        borderRadius: "6px",
                                        px: 1.5,
                                        py: 0.3,
                                      }}
                                    >
                                      ABHA
                                    </Box>
                                  )}
                                </Stack>
                              </TableCell>
                            </TableRow>

                            {/* Spoke Centers */}
                            {Array.isArray(center.spokeCenters) &&
                              center.spokeCenters.length > 0 &&
                              center.spokeCenters.map((spoke, si) => {
                                const isLastSpoke =
                                  si === center.spokeCenters.length - 1;
                                return (
                                  <TableRow
                                    key={spoke._id || si}
                                    sx={{
                                      fontFamily: "Figtree",
                                      "& td": {
                                        backgroundColor: "var(--app-surface)",
                                        borderBottom: "none",
                                      },
                                      "& > td:last-of-type": {
                                        borderTopRightRadius: "8px",
                                        borderBottomRightRadius: "8px",
                                      },
                                    }}
                                  >
                                    <TableCell
                                      sx={{
                                        position: "relative",
                                        backgroundColor: "transparent !important",
                                        // indented white card (starts after the 30px gutter)
                                        "&::before": {
                                          content: '""',
                                          position: "absolute",
                                          left: "30px",
                                          top: 0,
                                          bottom: 0,
                                          right: 0,
                                          backgroundColor: "var(--app-surface)",
                                          // strong accent on the child card's left edge only
                                          borderLeft: "3px solid var(--app-line)",
                                          borderTopLeftRadius: "8px",
                                          borderBottomLeftRadius: "8px",
                                        },
                                        // vertical trunk (bridges the row gap so lines touch);
                                        // for the last spoke it stops where the curve begins
                                        "&::after": {
                                          content: '""',
                                          position: "absolute",
                                          left: "16px",
                                          top: "-10px",
                                          width: "2px",
                                          height: isLastSpoke
                                            ? "50%"
                                            : "calc(100% + 10px)",
                                          backgroundColor: "var(--app-line)",
                                        },
                                      }}
                                    >
                                      {/* smooth rounded branch — stops at the spoke card's left border */}
                                      <Box
                                        sx={{
                                          position: "absolute",
                                          left: "16px",
                                          top: "calc(50% - 11px)",
                                          width: "14px",
                                          height: "11px",
                                          borderLeft: "2px solid var(--app-line)",
                                          borderBottom: "2px solid var(--app-line)",
                                          borderBottomLeftRadius: "11px",
                                        }}
                                      />
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        gap={1.5}
                                        sx={{ position: "relative", zIndex: 1, pl: "42px" }}
                                      >
                                        <Avatar
                                          src={spoke.logo || undefined}
                                          variant="square"
                                          sx={{
                                            width: 32,
                                            height: 32,
                                            backgroundColor: "#f0f0f0",
                                            mr: 1,
                                          }}
                                        >
                                          {!spoke.logo && (
                                            <Icon
                                              icon="icon-park-solid:hospital-three"
                                              width="25"
                                              height="25"
                                              style={{ color: "var(--app-text)" }}
                                            />
                                          )}
                                        </Avatar>
                                        <Box>
                                          <Typography
                                            sx={{
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              navigate(
                                                `/settings/centres/${spoke.id}`,
                                              )
                                            }
                                          >
                                            {spoke.name}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </TableCell>

                                    <TableCell>
                                      {spoke.phone
                                        ? `${spoke.countryCode ?? ""} ${spoke.phone
                                        }`
                                        : "-"}
                                    </TableCell>

                                    <TableCell>
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        gap={0.5}
                                      >
                                        <TypeIcon type={spoke.centerType} size={15} />
                                        {`${spoke.centerType
                                          .charAt(0)
                                          .toUpperCase()}${spoke.centerType
                                            .slice(1)
                                            .toLowerCase()} Centre`}
                                      </Box>
                                    </TableCell>

                                    <TableCell>
                                      <i className="bi bi-hospital me-2" />
                                      {spoke.type || "Spoke"}
                                    </TableCell>

                                    <TableCell>
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        sx={{ width: "100%" }}
                                      >
                                        <Typography>
                                          {spoke.address?.area || "--"},{" "}
                                          {spoke.address?.city || "--"}
                                        </Typography>
                                        {spoke.isAbhaVerified && (
                                          <Box
                                            sx={{
                                              display: "inline-block",
                                              backgroundColor: "#E7F7E7",
                                              color: "#2C7A2C",
                                              fontSize: "12px",
                                              fontWeight: 600,
                                              borderRadius: "6px",
                                              px: 1.5,
                                              py: 0.3,
                                            }}
                                          >
                                            ABHA
                                          </Box>
                                        )}
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}

                            {/* Divider */}
                            <TableRow>
                              <TableCell colSpan={5} sx={{ p: 0, border: 0 }}>
                                <Divider
                                  sx={{
                                    m: 0,
                                    height: "1px",
                                    backgroundColor: "var(--app-border)", // your custom color
                                    border: "none", // prevent table style interference
                                  }}
                                />
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>

                    {/* Infinite Scroll Footer */}
                    {isLoadingMore && (
                      <Box textAlign="center" py={2}>
                        <CircularProgress size={20} />
                        <Typography variant="caption" ml={1}>
                          Loading more...
                        </Typography>
                      </Box>
                    )}

                    {!hasMore && centersData.length > 0 && (
                      <Box
                        textAlign="center"
                        py={2}
                        sx={{ backgroundColor: "var(--app-surface-2)" }}
                      >
                        <Typography variant="caption">{""}</Typography>
                      </Box>
                    )}
                  </TableContainer>
                ) : (
                  <BlankPreview icon={nopreview} title="No Centers Available" />
                )}
              </Box>
            )}
          </div>
        </div>
      )}
    </>
  );
};

function Filter({ handleFilter, setSelectedCenter }) {
  const navigate = useNavigate();
  const sortOptions = [
    { label: "Newest to Oldest", value: "desc" },
    { label: "Oldest to Newest", value: "asc" },
  ];

  const [modelFilter, setModelFilter] = useState(false);
  const [sort, setsort] = useState("desc");
  const [selectedMenu, setSelectedMenu] = useState("sort-by");

  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { user } = useContext(AuthContext);
  // Migrated businesses don't get to add new centres from the UI -
  // userType stays plain "b2b", migration is a separate flag.
  const isMigratedUser = user?.userType === "b2b" && user?.migration === true;
  const [selectedHubIds, setSelectedHubIds] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedSort, setSelectedSort] = useState(sortOptions[0]);
  const [selectedSpokeIds, setSelectedSpokeIds] = useState([]);
  const [activeCenterType, setActiveCenterType] = useState(null);
  const { isCenterLimitReached } = useCreditWallet();


  const getEffectiveCenterIds = () => {
    if (selectedSpokeIds.length > 0) return selectedSpokeIds;
    if (selectedHubIds.length > 0) return selectedHubIds;
    return [];
  };

  const handleSelectChange = (selectedIds, centerType) => {
    const ids = Array.isArray(selectedIds) ? selectedIds : [];

    if (centerType === "hub") {
      setSelectedHubIds(ids);
      setSelectedSpokeIds([]);
      setActiveCenterType(ids.length ? "hub" : null);
    } else {
      setSelectedSpokeIds(ids);
      setActiveCenterType(
        ids.length ? "spoke" : selectedHubIds.length ? "hub" : null,
      );
    }
  };

  const applyFilter = () => {
    const centerIds = getEffectiveCenterIds();

    handleFilter({
      sort: selectedSort?.value || "desc",
      type: selectedTypes,
      searchText: searchTerm,

      ...(centerIds.length > 0 && {
        centerIds: JSON.stringify(centerIds),
        centerType: activeCenterType,
      }),
    });
  };

  useEffect(() => {
    applyFilter();
  }, [selectedHubIds, selectedSpokeIds]);

  const handleSearch = (value) => {
    const centerIds = getEffectiveCenterIds();

    handleFilter({
      sort: selectedSort?.value || "desc",
      role: selectedRoles.join(","),
      status: selectedStatuses.join(","),
      type: selectedTypes,
      searchText: value,

      ...(centerIds.length > 0 && {
        centerIds: JSON.stringify(centerIds),
        centerType: activeCenterType,
      }),
    });
  };

  const typeOptions = [
    { label: "Private Practice Clinic", value: "Private Practice Clinic" },
    { label: "Private Diagnostic centre", value: "Private Diagnostic centre" },
    { label: "Government Facility", value: "Government Facility" },
    { label: "Private Hospital", value: "Private Hospital" },
    { label: "Private AYUSH clinic", value: "Private AYUSH clinic" },
    { label: "Others", value: "Others" },
  ];

  const DropdownIcon = (props) => (
    <Icon
      icon="eva:arrow-ios-downward-fill"
      width="20"
      height="20"
      {...props} // ← IMPORTANT
    />
  );
  return (
    <>
      <div className="row">
        <Grid
          container
          spacing={2}
          alignItems="center"
          sx={{
            mt: 1,
            flexWrap: { xs: "wrap", md: "nowrap" },
          }}
        >
          {/* Search Input */}

          <TextField
            variant="outlined"
            placeholder="Search by Centre Name"
            onChange={(e) => handleSearch(e.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {/* <SearchIcon sx={{ color: "var(--app-text-muted)" }} /> */}
                  <img
                    src={SearchIconSvg}
                    alt="search"
                    style={{ width: 18, height: 18 }}
                  />
                </InputAdornment>
              ),
              sx: {
                // backgroundColor: "var(--app-surface-2)",
                borderRadius: "8px",
                border: "1px solid var(--app-border)",
                backgroundColor: "var(--app-surface)",
                height: "45px",
                fontSize: "14px",
                "& fieldset": { border: "none" },
              },
            }}
          />

          <RequireAuth role={["b2b"]} permission={"canManageUsers"}>
            {!isMigratedUser && (
              <Button
                component={Link}
                to="/add-centre"
                variant="contained"
                startIcon={<AddIcon />}
                onClick={(event) => {
                  if (isCenterLimitReached) {
                    // MUI's Button with component={Link} still performs the Link's own
                    // navigation after this handler runs unless the event is prevented -
                    // without this, clicking still lands on /add-centre regardless.
                    event.preventDefault();
                    toast.error(
                      "You've reached your plan's centre limit. Upgrade your plan to add more centres."
                    );
                  }
                }}
                sx={{
                  backgroundColor: "#5751E9",
                  boxShadow: "none",
                  fontSize: "14px",
                  fontWeight: 600,
                  textTransform: "none",
                  height: "45px",
                  borderRadius: "10px",
                  whiteSpace: "nowrap",
                  px: 5,
                  "&:hover": {
                    backgroundColor: "#433AC7",
                    color: "white",
                  },
                }}
              >
                Add New Centre
              </Button>
            )}
          </RequireAuth>
        </Grid>
      </div>


    </>
  );
}

export default Centres;
